module.exports = __webpack_public_path__ + "static/media/applePay-hero-2.983cccea.png";